import api from './client'

// API key record — matches backend apiKeys.List() / Create() fields.
export interface APIKey {
  id: string
  name: string
  created_at: number
  last_used?: number
  revoked?: boolean
}

// /api/keys GET → {keys: APIKey[]}
export interface ListKeysResponse {
  keys: APIKey[]
}

export async function listKeys(): Promise<APIKey[]> {
  const resp = await api.get<ListKeysResponse>('/api/keys')
  return resp.keys ?? []
}

// /api/keys POST {name} → {key: APIKey, secret: string}
export interface CreateKeyRequest {
  name: string
}

export interface CreateKeyResponse {
  key: APIKey
  secret: string
}

export async function createKey(payload: CreateKeyRequest): Promise<CreateKeyResponse> {
  return api.post<CreateKeyResponse>('/api/keys', payload)
}

// /api/keys DELETE ?id=xxx → {revoked: true}
export async function revokeKey(id: string): Promise<void> {
  return api.delete<void>('/api/keys', { query: { id } })
}
